// extracted by mini-css-extract-plugin
export default {"listingWrapper":"ListingsList-module-listingWrapper"};